import React, { useState } from "react";
import * as XLSX from "xlsx";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import {
  Box,
  Button,
  CircularProgress,
  Snackbar,
  Typography,
} from "@mui/material";

const ExcelDownloader = ({ collectionName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const handleDownload = async () => {
    setIsLoading(true);

    try {
      const snapshot = await getDocs(collection(db, collectionName));
      const data = [];

      // Header (en la fila 1)
      const headers = [
        "ORDEN EXCEL",
        "FAMILIA",
        "SUBFAM.",
        "PRODUCTO",
        "f1",
        "c1",
        "p1",
        "f2",
        "c2",
        "p2",
        "f3",
        "c3",
        "p3",
        "imagenUrl",
        "en",
        "cat",
        "fr",
      ];
      data.push(headers);

      snapshot.forEach((doc) => {
        const d = doc.data();
        const row = [];

        const getSafe = (v) => (v !== undefined && v !== null ? v : "");

        row.push(getSafe(d.ordenExcel));
        row.push(getSafe(d.familia));
        row.push(getSafe(d.subfam));
        row.push(getSafe(d.producto));

        // Rellenar formatos
        const formatos = d.formatos || [];
        for (let i = 0; i < 3; i++) {
          row.push(getSafe(formatos[i]?.formato));
          row.push(getSafe(formatos[i]?.cantidad));
          row.push(getSafe(formatos[i]?.precio));
        }

        row.push(getSafe(d.imagenUrl));
        row.push(getSafe(d.translations?.en?.name));
        row.push(getSafe(d.translations?.cat?.name));
        row.push(getSafe(d.translations?.fr?.name));

        data.push(row);
      });

      // Crear hoja y libro de Excel
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Productos");

      // Descargar
      XLSX.writeFile(workbook, `${collectionName}.xlsx`);
      setSnackbar({ open: true, message: "Excel exportado correctamente." });
    } catch (error) {
      console.error("Error al exportar:", error);
      setSnackbar({ open: true, message: "Error al exportar el Excel." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ padding: 2, textAlign: "center" }}>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Exportar Excel desde Firebase
      </Typography>
      <Button
        variant="contained"
        onClick={handleDownload}
        disabled={isLoading}
        sx={{ marginBottom: 2 }}
      >
        Descargar Excel
      </Button>
      {isLoading && <CircularProgress />}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />
    </Box>
  );
};

export default ExcelDownloader;
